import React, { useState } from "react";
import {
  LoadScript,
  GoogleMap,
  Marker,
  Autocomplete,
} from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "250px",
  borderRadius: "8px",
};

const center = {
  lat: 20.5937, // India center
  lng: 78.9629,
};

export default function LocationPicker() {
  const [map, setMap] = useState(null);
  const [autocomplete, setAutocomplete] = useState(null);
  const [position, setPosition] = useState(center);
  const [locationName, setLocationName] = useState("");

  const onLoad = (autoC) => setAutocomplete(autoC);

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      setLocationName(place.formatted_address || "");
      if (place.geometry) {
        setPosition({
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        });
        map.panTo(place.geometry.location);
      }
    }
  };

  return (
    <LoadScript
      googleMapsApiKey="AIzaSyDFN19T-8VAadXHJ2vdptqv7tNnGDrxly8"
      libraries={["places"]}
    >
      <div style={{ marginBottom: "10px" }}>
        <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
          <input
            type="text"
            placeholder="Enter location..."
            value={locationName}
            onChange={(e) => setLocationName(e.target.value)}
            style={{
              width: "100%",
              padding: "10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              outline: "none",
            }}
          />
        </Autocomplete>
      </div>

      <GoogleMap
        mapContainerStyle={containerStyle}
        center={position}
        zoom={12}
        onLoad={(map) => setMap(map)}
      >
        <Marker
          position={position}
          draggable
          onDragEnd={(e) => {
            setPosition({ lat: e.latLng.lat(), lng: e.latLng.lng() });
          }}
        />
      </GoogleMap>
    </LoadScript>
  );
}
